import { NDfs } from '../dfs.interfaces';

export function dfsDimension2String(dim: NDfs.IDimension): string {
    switch (dim.unit) {
        case 'q':
            return `${dim.value}*var(--dfs-quant)`;
        case 'c':
            return `var(--dfs-${dim.value}col)`;
        case 'g':
            return `${dim.value}*var(--dfs-gutter)`;
        default:
            return `${dim.value}${dim.unit}`;
    }
}
